import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "+964", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "required" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "required" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-lg-8 fv-row" }
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_65 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_66 = { class: "indicator-label" }
const _hoisted_67 = { class: "indicator-progress" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'driver'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewDriver')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.driverSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('fullName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "fullName",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('fullName')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "fullName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('email')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "email",
                      name: "email",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('email')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "email" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('phoneNumber')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "mobile",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('phoneNumber')
                      }, null, 8, ["placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "mobile" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('vehicle')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "vehicleId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedVehicle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVehicle) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.translate('selectVehicle')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicles, (vehicle) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: vehicle.id,
                            value: vehicle.id
                          }, _toDisplayString(vehicle.name.find((i) => {
                        return i.title;
                      }).title), 9, _hoisted_29))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "vehicleId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate('driverType')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "typeId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedDriver,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDriver) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.translate('selectDriver')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverTypes, (driverType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: driverType.id,
                            value: driverType.id
                          }, _toDisplayString(driverType.title), 9, _hoisted_37))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "typeId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.translate('hubs')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "hubId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedHubs,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedHubs) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.translate('selectHub')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hubs, (hub) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: hub.id,
                            value: hub.id
                          }, _toDisplayString(hub.titleTranslate), 9, _hoisted_45))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_ErrorMessage, { name: "hubId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      mode: "tags",
                      "close-on-select": false,
                      requierd: false,
                      label: "title",
                      trackBy: "title",
                      searchable: true,
                      canDeselect: false,
                      placeholder: _ctx.translate('selectArea'),
                      options: _ctx.areasTitle(),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "placeholder", "options", "noResultsText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('offices')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedOffice,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedOffice) = $event)),
                      mode: "tags",
                      "close-on-select": false,
                      requierd: false,
                      label: "title",
                      trackBy: "title",
                      searchable: true,
                      canDeselect: false,
                      placeholder: _ctx.translate('selectOffice'),
                      options: _ctx.officesTitle(),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "placeholder", "options", "noResultsText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate('profileImage')) + ": ", 1),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_Field, {
                      type: "file",
                      accept: "image/*",
                      name: "logo",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('profileImage')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "logo" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate('licenseImage')) + ": ", 1),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_Field, {
                      type: "file",
                      accept: "image/*",
                      name: "image",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('licenseImage')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_ErrorMessage, { name: "image" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_65, [
                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_67, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_68
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}